export const StyleSettings: any = {
  "font": 13,
  "control_height": 30,
  "control_minWidth": 100,
}